import styled from "styled-components";

export const StyledExerciseDataCircle = styled.div`
  .circle-width {
    width: 90;
  }

  .data-circle-styling {
    margin-left: auto;
    margin-right: auto;
  }
`;
